import { SVGProps } from "react";

export function ResetIcon({
  size = 24,
  color = "currentColor",
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props as any)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9998 5.00002V6.99998L16.781 6.99984C18.4721 8.48386 19.5086 10.6557 19.5066 13.0221C19.5036 16.6867 17.0109 19.8807 13.4569 20.7741C9.90279 21.6674 6.1961 20.0317 4.4606 16.804C2.72515 13.5764 3.40465 9.58219 6.1098 7.11C6.49198 7.71808 7.03085 8.21205 7.6698 8.54002C6.99125 9.08821 6.44412 9.78145 6.0686 10.5688C5.69308 11.3562 5.49871 12.2177 5.49977 13.09C5.54899 16.3685 8.22091 19.0004 11.4998 19C14.5031 19.0495 17.0643 16.8346 17.4485 13.8555C17.7356 11.6297 16.739 9.50831 14.9999 8.27986L14.9998 12H12.9998V5.00002H19.9998ZM9.4998 3C10.6044 3 11.4998 3.89545 11.4998 5.00002C11.4998 6.10458 10.6044 6.99998 9.4998 6.99998C8.39524 6.99998 7.49979 6.10458 7.49979 5.00002C7.49979 3.89545 8.39524 3 9.4998 3Z"
        fill={color}
      />
    </svg>
  );
}
